import { useMutation } from "@tanstack/vue-query";
import Unipile from "@/services/unipile/unipile";
import type { Message } from "@/dtos/Unipile.dto";

/**
 * Composable for reacting to Unipile-backed messages (LinkedIn, WhatsApp) using TanStack Query
 */
export function useReactToUnipileMessage() {
  const addReactionMutation = useMutation({
    mutationFn: async ({ messageId, reaction }: { messageId: string; reaction: string }) => {
      const response = await Unipile.addReaction(messageId, { reaction });
      return response.data;
    },
  });

  const removeReactionMutation = useMutation({
    mutationFn: async (messageId: string) => {
      const response = await Unipile.removeReaction(messageId);
      return response.data;
    },
  });

  const addReaction = async (
    messageId: string,
    reaction: string
  ): Promise<Message["reactions"]> => {
    const data = await addReactionMutation.mutateAsync({ messageId, reaction });
    return data.data.reactions;
  };

  const removeReaction = async (messageId: string): Promise<Message["reactions"]> => {
    const data = await removeReactionMutation.mutateAsync(messageId);
    return data.data.reactions;
  };

  return {
    addReaction,
    removeReaction,
    isReacting: addReactionMutation.isPending,
    isRemovingReaction: removeReactionMutation.isPending,
  };
}
